// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__FRtlu","head":"ProcedureTableInfo_head__1zmmq"};